import { Component, OnInit, Injectable } from '@angular/core';
import { UsuarioDTO } from '../../models/UsuarioDTO';
import { EventEmitter } from 'protractor';
import { DatePipe } from '../../../../node_modules/@angular/common';
import { Observable, BehaviorSubject, Subject, Subscription, Observer } from 'rxjs';
import { ToastaService, ToastaConfig, ToastOptions, ToastData } from 'ngx-toasta';

@Component({
	selector: 'app-global',
	template: ''
})
@Injectable()
export class Global {
	PacienteDto: UsuarioDTO;
	langSubscription: Subscription;

	constructor(private toastaService: ToastaService, private toastaConfig: ToastaConfig) {
		toastaConfig.position = 'top-center';
	}

	mensaje(titulo: string, mensaje: string, tipo: string) {
		const toastOptions: ToastOptions = {
			title: titulo,
			msg: mensaje,
			showClose: true,
			timeout: 8000,
			theme: 'default',
			onAdd: (toast: ToastData) => {
				// console.log('Toast ' + toast.id + ' has been added!');
			},
			onRemove: function(toast: ToastData) {
				// console.log('Toast ' + toast.id + ' has been removed!');
			}
		};
		switch (tipo) {
			case 'info':
				this.toastaService.info(toastOptions);
				break;
			case 'success':
				this.toastaService.success(toastOptions);
				break;
			case 'wait':
				this.toastaService.wait(toastOptions);
				break;
			case 'error':
				this.toastaService.error(toastOptions);
				break;
			case 'warning':
				this.toastaService.warning(toastOptions);
				break;
		}
	}

	getToken(): string {
		let token;
		if (sessionStorage.getItem('usuario') != undefined) {
			this.PacienteDto = JSON.parse(sessionStorage.getItem('usuario'));
			token = this.PacienteDto.token;
		}
		return token;
	}

	getFechaHoyAnonymous(fechaHoy): Date {
		return new Date(fechaHoy);
	}

	getFechaFormateada(fechaHoy: Date) {
		let fechaPipe = new DatePipe('es_AR');
		return fechaPipe.transform(fechaHoy, 'dd/MM/yyyy');
	}

	getFechaFormateadaBusqueda(fechaHoy: Date) {
		let fechaPipe = new DatePipe('es_AR');
		return fechaPipe.transform(fechaHoy, 'dd-MM-yyyy');
	}

	agregarDias(date: Date, days: number): Date {
		date.setDate(date.getDate() + days);
		return date;
	}

	agregarMes(date: Date, days: number): Date {
		date.setDate(date.getDate() + days);
		return date;
	}

	toDate(fechaDB: string): string {
		let fecha = new Date(fechaDB);
		let fechaPipe = new DatePipe('es_AR');
		return fechaPipe.transform(fecha, 'dd/MM/yyyy');
	}

	funcFormatFecha(fecha) {
		let fechaString: string = null;
		fechaString = fecha.year.toString();
		if (fecha.month < 10) {
			fechaString += '-0' + fecha.month;
		} else {
			fechaString += '-' + fecha.month;
		}
		if (fecha.day < 10) {
			fechaString += '-0' + fecha.day;
		} else {
			fechaString += '-' + fecha.day;
		}
		return fechaString;
	}
}
